module.exports = __webpack_public_path__ + "static/media/logLiquidConsumedActive.df01ade1.svg";